import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { META_COLLECT_API } from '../../../../../../api';
import { ContainerListPage } from '../../../../../../components/List/styles';
import { ModalInfoTemplete } from '../../../../../../components/Modal/ModalInfoTemplete';
import {
  ContainerItemModal,
  RowItens,
} from '../../../../../../components/Modal/ModalInfoTemplete/styles';
import { PageHeader, ViewMode } from '../../../../../../components/PageHeader';
import { useSigninContext } from '../../../../../../context/AuthProviderPages/Signin';
import {
  ContainerPage,
  PageContent,
} from '../../../../../../styles/global.styles';
import { formatClassificacao } from '../../../../../../utils/formatClassificacao';
import { QualidadeItem } from '../../page';

type ContentWrapperProps = {
  loading: boolean;
  row: QualidadeItem | null;
  openModal: boolean;
  handleCloseModal: () => void;
  children: React.ReactNode;
  modifyViewMode?: ViewMode;
  setModifyViewMode?: Dispatch<SetStateAction<ViewMode>>;
  filterAction?: () => void;
};

type ModalProps = {
  row: QualidadeItem;
  openModal: boolean;
  handleCloseModal: () => void;
};

type ItemAnalise = {
  DFDESCANALISE: string;
  DFSIGLAANALISE: string;
  DFMEDIA: number;
  DFMEDIATRIMESTRE: number;
};

const Modal = ({ row, openModal, handleCloseModal }: ModalProps) => {
  const { path } = useSigninContext();
  const [itensAnalise, setItensAnalise] = useState<ItemAnalise[]>([]);
  const [loadingItens, setLoadingItens] = useState<boolean>(false);

  useEffect(() => {
    if (openModal && row) {
      const fetchItensAnalise = async () => {
        setLoadingItens(true);
        try {
          const { data: response } = await META_COLLECT_API.get(
            `/pqfl/qualidade/${row.DFIDCALCANALISE}/itens`,
            {
              headers: { path },
            },
          );
          setItensAnalise(response.data || []);
        } catch (error) {
          console.error('Erro ao buscar itens da análise:', error);
          setItensAnalise([]);
        } finally {
          setLoadingItens(false);
        }
      };

      fetchItensAnalise();
    }
  }, [openModal, row, path]);

  return (
    <ModalInfoTemplete
      option="pqfl_qualidade"
      titleModal="Detalhes da Análise"
      closeModal={handleCloseModal}
      isOpen={openModal}
    >
      <RowItens
        style={{
          marginBottom: '10px',
        }}
      >
        <ContainerItemModal>
          <label>ID da Análise</label>
          <div>
            <span>{row.DFIDCALCANALISE}</span>
          </div>
        </ContainerItemModal>
        <ContainerItemModal>
          <label>Classificação</label>
          <div>
            <span>{formatClassificacao(row.DFCLASSIFICADO)}</span>
          </div>
        </ContainerItemModal>
      </RowItens>
      <RowItens
        style={{
          marginBottom: '10px',
        }}
      >
        <ContainerItemModal>
          <label>Matrícula</label>
          <div>
            <span>{row.DFMATRICULA}</span>
          </div>
        </ContainerItemModal>
        <ContainerItemModal>
          <label>CPF/CNPJ</label>
          <div>
            <span>{row.DFCNPJCPFCEI}</span>
          </div>
        </ContainerItemModal>
      </RowItens>
      <RowItens
        style={{
          marginBottom: '10px',
        }}
      >
        <ContainerItemModal>
          <label>Produtor</label>
          <div>
            <span>{row.DFNOMEPRODUTOR}</span>
          </div>
        </ContainerItemModal>
        <ContainerItemModal>
          <label>Propriedade</label>
          <div>
            <span>{row.DFNOMEPROPRIEDADE}</span>
          </div>
        </ContainerItemModal>
      </RowItens>

      <RowItens
        style={{
          marginBottom: '10px',
          marginTop: '20px',
        }}
      >
        <h2>Itens da Análise:</h2>
      </RowItens>

      {loadingItens && (
        <RowItens>
          <div
            style={{
              textAlign: 'center',
              padding: '20px',
              color: '#999',
              width: '100%',
            }}
          >
            Carregando itens...
          </div>
        </RowItens>
      )}

      {!loadingItens && itensAnalise.length > 0 && (
        <RowItens>
          <ContainerListPage
            style={{
              width: '100%',
              overflow: 'auto',
            }}
          >
            <table>
              <thead>
                <tr>
                  <th className="first-table-th">Sigla</th>
                  <th className="list-th">Análise</th>
                  <th className="list-th">Média</th>
                  <th className="list-th">Média Trimestre</th>
                </tr>
              </thead>
              <tbody>
                {itensAnalise.map(item => (
                  <tr key={`${item.DFSIGLAANALISE}-${item.DFMEDIA}`}>
                    <td className="list-td-small">{item.DFSIGLAANALISE}</td>
                    <td className="list-td-large">{item.DFDESCANALISE}</td>
                    <td className="list-td-small">{item.DFMEDIA}</td>
                    <td className="list-td-small">{item.DFMEDIATRIMESTRE}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </ContainerListPage>
        </RowItens>
      )}

      {!loadingItens && itensAnalise.length === 0 && (
        <RowItens>
          <div
            style={{
              textAlign: 'center',
              padding: '20px',
              color: '#999',
              width: '100%',
            }}
          >
            Nenhum item encontrado para esta análise
          </div>
        </RowItens>
      )}
    </ModalInfoTemplete>
  );
};

export const ContentWrapper = ({
  loading,
  row,
  openModal,
  handleCloseModal,
  children,
  modifyViewMode,
  setModifyViewMode,
  filterAction,
}: ContentWrapperProps) => {
  return (
    <>
      <PageHeader
        pageIcon={{ option: 'pqfl_qualidade' }}
        pageTitle="PQFL / Qualidade"
        hasFilter
        filterAction={filterAction}
        modifyViewMode={modifyViewMode}
        setModifyViewMode={setModifyViewMode}
      />
      <ContainerPage>
        <PageContent
          style={{
            justifyContent: loading === true ? 'center' : 'space-between',
          }}
        >
          {children}
        </PageContent>
        {row && (
          <Modal
            row={row}
            openModal={openModal}
            handleCloseModal={handleCloseModal}
          />
        )}
      </ContainerPage>
    </>
  );
};
